import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import sidebarData from "./SidebarData";
// Simple bar
import SimpleBar from "simplebar-react";
// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { Link } from "react-router-dom";
// i18n
import { withTranslation } from "react-i18next";

const Sidebar = (props) => {
  const ref = useRef();

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu-item");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu-item");
    activeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      {/* ── Scoped styles injected once ── */}
      <style>{`
        /* ── Sidebar shell ── */
        .vertical-menu {
          background-color: #ffffff;
          border-right: 1px solid #e9ecef;
          box-shadow: 2px 0 12px rgba(0, 0, 0, 0.06);
        }

        /* ── Section title ── */
        #sidebar-menu .menu-title {
          font-size: 0.65rem;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #adb5bd;
          padding: 1.1rem 1.25rem 0.4rem;
          margin-top: 0.25rem;
        }

        /* ── Every nav link ── */
        #sidebar-menu ul li a {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 20px;
          color: #495057;
          font-size: 0.875rem;
          font-weight: 500;
          border-radius: 8px;
          margin: 2px 10px;
          transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
          text-decoration: none;
          position: relative;
        }

        /* ── Hover state ── */
        #sidebar-menu ul li a:hover {
          background-color: #f0f4ff;
          color: #3b5bdb;
          box-shadow: 0 1px 6px rgba(59, 91, 219, 0.1);
        }

        #sidebar-menu ul li a:hover i {
          color: #3b5bdb;
        }

        /* ── Active / mm-active state ── */
        #sidebar-menu ul li a.active,
        #sidebar-menu ul li.mm-active > a {
          background-color: #3b5bdb;
          color: #ffffff !important;
          box-shadow: 0 4px 14px rgba(59, 91, 219, 0.35);
          font-weight: 600;
        }

        #sidebar-menu ul li a.active i,
        #sidebar-menu ul li.mm-active > a i {
          color: #ffffff !important;
        }

        /* ── Active left accent bar ── */
        #sidebar-menu ul li a.active::before,
        #sidebar-menu ul li.mm-active > a::before {
          content: "";
          position: absolute;
          left: -10px;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 60%;
          border-radius: 0 4px 4px 0;
          background-color: #3b5bdb;
        }

        /* ── Icons ── */
        #sidebar-menu ul li a i {
          font-size: 1rem;
          color: #868e96;
          transition: color 0.18s ease;
          flex-shrink: 0;
        }

        /* ── Sub-menu ── */
        #sidebar-menu .sub-menu {
          padding-left: 0;
          margin: 0;
        }

        #sidebar-menu .sub-menu li a {
          padding: 8px 20px 8px 48px;
          font-size: 0.82rem;
          color: #6c757d;
          font-weight: 400;
          border-radius: 8px;
          margin: 1px 10px;
        }

        #sidebar-menu .sub-menu li a:hover {
          background-color: #f0f4ff;
          color: #3b5bdb;
        }

        #sidebar-menu .sub-menu li a.active {
          background-color: #dbe4ff;
          color: #3b5bdb !important;
          font-weight: 600;
          box-shadow: none;
        }

        /* ── Badge ── */
        #sidebar-menu .badge {
          font-size: 0.65rem;
          padding: 3px 7px;
          border-radius: 20px;
          margin-left: auto;
        }

        /* ── Arrow for collapsible menus ── */
        #sidebar-menu ul li a.has-arrow::after {
          margin-left: auto;
          font-size: 0.7rem;
          color: #adb5bd;
          transition: transform 0.2s ease;
        }

        #sidebar-menu ul li.mm-active > a.has-arrow::after {
          color: #ffffff;
          transform: rotate(-180deg);
        }

        /* ── SimpleBar track ── */
        .simplebar-scrollbar::before {
          background-color: #dee2e6;
          border-radius: 4px;
        }
      `}</style>

      <div className="vertical-menu">
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {(sidebarData || []).map((item, key) => (
                <React.Fragment key={key}>
                  {item.isMainMenu ? (
                    <li className="menu-title">{props.t(item.label)}</li>
                  ) : (
                    <li key={key}>
                      <Link
                        to={item.url ? item.url : "/#"}
                        className={
                          item.issubMenubadge || item.isHasArrow
                            ? " "
                            : "has-arrow"
                        }
                      >
                        <i
                          className={item.icon}
                          style={{ marginRight: "5px" }}
                        ></i>
                        {item.issubMenubadge && (
                          <span
                            className={
                              "badge rounded-pill float-end " + item.bgcolor
                            }
                          >
                            {" "}
                            {item.badgeValue}{" "}
                          </span>
                        )}
                        <span>{props.t(item.label)}</span>
                      </Link>
                      {item.subItem && (
                        <ul className="sub-menu">
                          {item.subItem.map((item, key) => (
                            <li key={key}>
                              <Link
                                to={item.link}
                                className={
                                  item.subMenu && "has-arrow waves-effect"
                                }
                              >
                                {props.t(item.sublabel)}
                              </Link>
                              {item.subMenu && (
                                <ul className="sub-menu">
                                  {item.subMenu.map((item, key) => (
                                    <li key={key}>
                                      <Link to="#">
                                        {props.t(item.title)}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sidebar));